import { useQuery } from "@tanstack/react-query";

import { apiFetch } from "@/lib/api";
import type { Documento } from "@/types/api";

export function useDocumenti() {
  return useQuery({
    queryKey: ["documenti"],
    queryFn: () => apiFetch<Documento[]>("/api/v1/documenti"),
  });
}
